import { alpha, Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  marginLeft: 'auto',
  margin: '-4px 0 -4px auto',
  flexShrink: 0,
  backgroundColor: 'white',
  padding: '0 8px',
  height: 32,
  borderRadius: 4,
  border: `1px solid ${alpha(spaceCadet[300], 0.3)}`,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  cursor: 'pointer',
  overflow: 'visible',
  position: 'relative',

  '& .label': {
    color: spaceCadet[400],
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 400,
    flexShrink: 0,
    userSelect: 'none',
  },

  '& .value': {
    color: spaceCadet[500],
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 600,
    minWidth: 16,
  },

  '& .updatable-wrapper': {
    width: 60,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',

    '& .MuiButton-root.edit-button': {
      visibility: 'hidden',
      color: spaceCadet[400],
      minWidth: 'unset',
      padding: 2,
      height: 18,
      lineHeight: '18px',
      '& svg': {
        fontSize: 12,
      },
    },

    '&:hover .MuiButton-root.edit-button': {
      visibility: 'visible',
    },

    '& .MuiTextField-root, & .MuiFormControl-root': {
      margin: 0,
    },

    '& .MuiInputBase-root': {
      height: 22,
      fontSize: 11,
      fontWeight: 600,
      color: spaceCadet[500],
      width: '100%',
      '& input': {
        padding: '0 2px',
        height: '100%',
        boxSizing: 'border-box',
      },
      '& fieldset': {
        display: 'none',
      },
    },
  },
});

export default StyledBox;
